export const contactContent = {
  hero: {
    title: "Contact Us",
    subtitle: "Get in touch with our family support team"
  },
  section: {
    title: "Say Hello! 👋",
    subtitle: "Questions? Ideas? Just want to tell us we're awesome? We're all ears!"
  },
  form: {
    title: "Send us a message",
    successMessage: "Thank you for contacting us! We will respond within 4 business hours.",
    defaultErrorMessage: "Failed to submit message. Please try again.",
    networkErrorMessage: "Network error. Please check your connection and try again or email hello@familycast.app",
    fields: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      message: "Message",
      messageHelper: "/1000 characters"
    },
    button: {
      default: "Send Message",
      submitting: "Sending..."
    }
  },
  contactInfo: {
    title: "Get in touch",
    items: [
      {
        iconName: "Email",
        title: "Email",
        value: "hello@familycast.app",
        subtext: "We respond within 4 business hours"
      },
      {
        iconName: "Article",
        title: "Blog",
        value: "blog.familycast.app",
        subtext: "Family organization tips, updates, and inspiration",
        link: "https://blog.familycast.app"
      },
      {
        iconName: "Upcoming",
        title: "Social Media",
        value: "Coming Soon! 🎉",
        subtext: "We're building our social presence! Follow our blog for updates."
      }
    ]
  }
};
